import { render, staticRenderFns } from "./FCB.vue?vue&type=template&id=0d21f51b"
import script from "./FCB.vue?vue&type=script&lang=js"
export * from "./FCB.vue?vue&type=script&lang=js"
import style0 from "./FCB.vue?vue&type=style&index=0&id=0d21f51b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports